export default function hash(length) : string {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

export function stringStartsWith (str: string, search: string): boolean {
   str = str.toLowerCase();
   search = search.toLowerCase();
 
   return str.substring(0, search.length) === search;
 }
 
 export function isJSON(str) {
   try {
       return (JSON.parse(str) && !!str);
   } catch (e) {
       return false;
   }
 }